import { Form } from '@/components/ui/form';

// Don't use `Form` (ShadCN default), because it sometimes gets auto-imported from `react-hook-form` by mistake.
export const FormWrapper = Form;
